import React from "react";
import { type DropdownWithoutOptionsProps } from "../models";
import BaseReactSelectDropdown from "./BaseReactSelectDropdown";

// The server reference has no custom option, and a custom value carries its own label as text
const customOption: server.dto.TimetableEntryType = {
  value: "custom",
  text: RESX.GeneralLabels.CustomValue
};

const TimetableEntryTypeDropdown = (props: DropdownWithoutOptionsProps<server.dto.TimetableEntryType, server.dto.TimetableEntryTypes>) => {
  return <BaseReactSelectDropdown
    excludeKeys={props.excludeKeys}
    options={[...serverReference.timetableEntryTypes, customOption]}
    getLabel={t => t.text}
    getValue={t => t.value}
    value={props.value.value === "custom" ? customOption : props.value}
    onChange={props.onChange}
    onEsc={props.onEsc}
    config={{
      isSearchable: true,
      ...props.config,
    }}
  />;
};

export default TimetableEntryTypeDropdown;
